import React from 'react';
import { Pie } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import colors from '../utils/colors';

const ChartPie = (props) => {
  const { dataLabels, numbersChart, options, height, width, legend } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: colors,
      },
    ],
  };

  return (
    <Pie
      data={data}
      legend={legend}
      options={options}
      height={height}
      width={width}
    />
  );
};

ChartPie.propTypes = {
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
  height: PropTypes.number,
  width: PropTypes.number,
  legend: PropTypes.shape({
    display: PropTypes.bool,
  }),
};

ChartPie.defaultProps = {
  dataLabels: [],
  options: {},
  height: 300,
  width: 300,
  legend: {
    display: true,
  },
};

export default withTranslation('common')(ChartPie);
